import {LiveCasinoFilterButtonIconDefaultBox} from "./live-casino-filter-button-icon.default.box";

export const LiveCasinoFilterButtonIconBox = LiveCasinoFilterButtonIconDefaultBox;